// Letzte Verteidigungslinie gegen das elastische Ueberscrollen auf iOS.
//
// index.css stellt html/body fest und macht #root (bzw. verschachtelte
// Container wie Drawer.tsx/LaenderSortieren.tsx) zum einzigen echten
// Scroll-Bereich, dazu overscroll-behavior:none. Reicht in einer als
// Homescreen-App installierten PWA trotzdem nicht immer: WebKit haelt sich
// dort nicht zuverlaessig an overscroll-behavior (offener WebKit-Fehler),
// das Ziehen ueber den Rand hinaus blieb sichtbar.
//
// touchmove faengt deshalb selbst ab, sobald eine Geste ueber den Rand des
// naechsten scrollbaren Vorfahren hinaus ziehen wuerde - unabhaengig davon,
// ob das #root ist oder ein verschachtelter Bereich wie der Drawer.
// Normales Scrollen (Rand noch nicht erreicht) bleibt unberuehrt.

function istScrollbar(el: Element): boolean {
  const stil = getComputedStyle(el);
  return /(auto|scroll)/.test(stil.overflowY) && el.scrollHeight > el.clientHeight;
}

function naechsterScrollbarerVorfahr(el: Element | null): Element | null {
  while (el && el !== document.body) {
    if (istScrollbar(el)) return el;
    el = el.parentElement;
  }
  return null;
}

export function sperreUeberscrollen(): void {
  let letzteY = 0;

  document.addEventListener(
    "touchstart",
    (e) => {
      letzteY = e.touches[0]?.clientY ?? 0;
    },
    { passive: true },
  );

  document.addEventListener(
    "touchmove",
    (e) => {
      const y = e.touches[0]?.clientY ?? letzteY;
      const ziehtNachUnten = y > letzteY;
      letzteY = y;

      const ziel = naechsterScrollbarerVorfahr(e.target as Element | null);
      // Kein scrollbarer Vorfahre (die Seite passt ganz auf den Bildschirm):
      // dann gibt es nichts zu scrollen, jede vertikale Geste waere ein
      // Ueberscrollen.
      if (!ziel) {
        e.preventDefault();
        return;
      }

      const amAnfang = ziel.scrollTop <= 0;
      const amEnde = ziel.scrollTop + ziel.clientHeight >= ziel.scrollHeight - 1;
      if ((amAnfang && ziehtNachUnten) || (amEnde && !ziehtNachUnten)) e.preventDefault();
    },
    // Nicht passiv: preventDefault() muss wirken duerfen.
    { passive: false },
  );
}
